import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.homePage'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: i18n.t('menu.userManagement'),
    icon: 'el-icon-user',
    children: [
      {
        title: i18n.t('model.user'),
        route: { name: 'users.index' }
      },
      {
        title: i18n.t('model.adminUsersRole'),
        route: { name: 'admin_users_roles.index' }
      },
      {
        title: i18n.t('model.role'),
        route: { name: 'roles.index' }
      },
      {
        title: i18n.t('model.student'),
        route: { name: 'students.index' }
      },
      {
        title: i18n.t('model.inviteRelationship'),
        route: { name: 'invite_relationships.index' }
      },
    ]
  },
  {
    title: '精选',
    icon: 'el-icon-star-off',
    children: [
      {
        title: i18n.t('model.article'),
        route: { name: 'articles.index' }
      },
      {
        title: i18n.t('model.specialColumn'),
        route: { name: 'special_columns.index' }
      },
    ]
  },
  {
    title: '有爱',
    icon: 'el-icon-sunny',
    children: [
      {
        title: i18n.t('model.youthCamp'),
        route: { name: 'youth_camps.index' }
      },
      {
        title: i18n.t('model.bookClub'),
        route: { name: 'book_clubs.index' }
      },
      {
        title: i18n.t('model.bookList'),
        route: { name: 'book_lists.index' }
      },
      {
        title: i18n.t('model.podcast'),
        route: { name: 'podcasts.index' }
      },
      {
        title: i18n.t('model.applyRecord'),
        route: { name: 'apply_records.index' }
      },
      {
        title: i18n.t('model.priceTypeTemplate'),
        route: { name: 'price_type_templates.index' }
      },
      {
        title: i18n.t('model.reason'),
        route: { name: 'reasons.index' }
      }
    ]
  },
  {
    title: '求真',
    icon: 'el-icon-question',
    children: [
      {
        title: i18n.t('model.seekTruthVideo'),
        route: { name: 'seek_truth_videos.index' }
      },
      {
        title: i18n.t('model.seekTruthWeekly'),
        route: { name: 'seek_truth_weeklies.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.pageManagement'),
    icon: 'el-icon-s-management',
    children: [
      {
        title: i18n.t('model.banner'),
        route: { name: 'banners.index' }
      },
      {
        title: i18n.t('model.activeStorageBlob'),
        route: { name: 'active_storage/blobs.index' },
        can: ['active_storage_blobs.read']
      },
      {
        title: i18n.t('model.customPage'),
        route: { name: 'custom_pages.index' }
      },
      {
        title: i18n.t('model.page'),
        route: { name: 'pages.index' }
      },
      {
        title: i18n.t('model.customPostList'),
        route: { name: 'custom_post_lists.index' }
      },
    ]
  },
  {
    title: i18n.t('model.normalComment'),
    icon: 'el-icon-s-comment',
    route: { name: 'normal_comments.index' }
  },
  {
    title: i18n.t('model.hotWord'),
    icon: 'el-icon-search',
    route: { name: 'hot_words.index' }
  },
  // 以下代码为generator插入代码的标记，请勿修改或删除
  // Generator menu
  {
    title: i18n.t('model.invoiceApplyRecord'),
    icon: 'el-icon-s-ticket',
    route: { name: 'invoice_apply_records.index' }
  },
  {
    title: i18n.t('model.application'),
    icon: 'el-icon-menu',
    route: { name: 'applications.index' },
    can: ['applications.read_list_menu']
  },
  {
    title: i18n.t('model.application'),
    icon: 'el-icon-menu',
    route: { name: 'applications.show', params: { id: 'current' } },
    can: ['applications.read_detail_menu']
  }
];
